import type { EffectDefinition, EffectContext } from './types'

interface Star {
  x: number
  y: number
  radius: number
  baseOpacity: number
  phase: number
  twinkleSpeed: number
}

export const stars: EffectDefinition = {
  id: 'stars',
  name: 'Starfield',

  init(ctx: EffectContext) {
    const count = Math.floor((ctx.width * ctx.height) / 4000)
    const items: Star[] = []
    for (let i = 0; i < count; i++) {
      items.push({
        x: Math.random() * ctx.width,
        y: Math.random() * ctx.height,
        radius: 0.5 + Math.random() * 1.8,
        baseOpacity: 0.2 + Math.random() * 0.5,
        phase: Math.random() * Math.PI * 2,
        twinkleSpeed: 0.5 + Math.random() * 2
      })
    }
    return items
  },

  update(_state: unknown, _ctx: EffectContext) {
    // Stars are static, animation is in draw via time
  },

  draw(state: unknown, ctx: EffectContext) {
    const items = state as Star[]
    const { ctx: c, time } = ctx
    const t = time / 1000

    for (const star of items) {
      const twinkle = (Math.sin(t * star.twinkleSpeed + star.phase) + 1) / 2
      const opacity = star.baseOpacity * (0.3 + twinkle * 0.7)

      c.beginPath()
      c.arc(star.x, star.y, star.radius, 0, Math.PI * 2)
      c.fillStyle = `rgba(255, 255, 255, ${opacity})`
      c.fill()

      // Subtle glow on brighter stars
      if (star.radius > 1.2 && twinkle > 0.7) {
        c.beginPath()
        c.arc(star.x, star.y, star.radius * 3, 0, Math.PI * 2)
        c.fillStyle = `rgba(255, 255, 255, ${opacity * 0.1})`
        c.fill()
      }
    }
  }
}
